import { captureException, withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { Toaster } from '@/components/molecules/Toaster'
import { withFallback } from '@/lib/searchParams'
import { SentryErrorPage } from '@/pages/error/SentryErrorPage'
import { JudicialResultListPage } from '@/pages/judicial/JudicialResultListPage'
import { judicialPreanalysesQuery } from '@/state/judicial/judicialPreanalyses'
import { judicialRecordsQuery } from '@/state/judicial/judicialRecords'

export const JudicialFilterZod = z.enum(['all', 'completed', 'accepted', 'completeRefusal'])
export type JudicialFilter = z.infer<typeof JudicialFilterZod>

export const JudicialTabZod = z.enum(['preanalysis', 'verifications'])
export type JudicialTab = z.infer<typeof JudicialTabZod>

export const JudicialPreanalysisFilterZod = z.enum(['open', 'new', 'inProgress', 'toCommunicate', 'done'])
export type JudicialPreanalysisFilter = z.infer<typeof JudicialPreanalysisFilterZod>

const judicialSearchZod = z.object({
  tab: withFallback(JudicialTabZod, 'preanalysis'),
  filter: withFallback(JudicialFilterZod, 'all'),
  preanalysisFilter: withFallback(JudicialPreanalysisFilterZod, 'open'),
})

const JudicialResultListComponent = () => (
  <>
    <Toaster />
    <JudicialResultListPage />
  </>
)

export const Route = createFileRoute('/judicial/')({
  component: withErrorBoundary(JudicialResultListComponent, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  validateSearch: judicialSearchZod,
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.prefetchQuery(judicialRecordsQuery()),
      context.queryClient.prefetchQuery(judicialPreanalysesQuery()),
    ])
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
